import { Component } from '@angular/core';
import { FileManagerComponent } from '../../../components/pages/file-manager/file-manager.component';

@Component({
  selector: 'app-management-file-manager',
  imports: [FileManagerComponent],
  templateUrl: './management-file-manager.component.html',
  styleUrl: './management-file-manager.component.scss'
})
export class ManagementFileManagerComponent {
  initialPath: string = 'management';
}
